/**
 * @author NikolaV
 */
import { LayerWrapper } from '../LayerWrapper';
import { FeatureLike } from 'ol/Feature';
import OlMap from 'ol/Map';
import OlLayer from 'ol/layer/Layer';


export class FeatureMouseInteraction<T extends LayerWrapper<any> = LayerWrapper<any>> {
    public map: OlMap;

    // layerWrapper will inject these
    public layer: OlLayer | undefined;
    public layerWrapper: T;

    constructor(map: OlMap) {
        this.map = map;
    }

    onClick = (feature: FeatureLike | FeatureLike[], e?, n?, featuresAtPixel?: FeatureLike[]): void => {

    };

    onMouseOver = (feature: FeatureLike, e?, n?): void => {

    };

    onRightClick = (feature: FeatureLike, e?, n?): void => {
    };
}
